import React from "react";
import { MentionableUserFragment } from "__generated__/graphql";
import { EmployeeAvatar } from "employee/partials/EmployeeAvatar";
import { Box } from "@mui/material";

interface IItemTemplateProps {
  data: MentionableUserFragment;
}
export const ItemTemplate: React.FC<IItemTemplateProps> = ({ data }) => {
  return (
    <Box sx={{ p: 1 }}>
      <EmployeeAvatar employee={data.employee} />
    </Box>
  );
};
